import api, { BuildInformationJsonData, buildOrganizationLabel } from './MeshApi';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from './AuthService';

const fetchLimit = 25;

const Builds = () => {
  const [data, setData] = useState<BuildInformationJsonData[] | null>(null);
  const [hasPrevious, setHasPrevious] = useState(true);
  const [hasNext, setHasNext] = useState(true);
  const [offset, setOffset] = useState(0);

  const navigate = useNavigate();

  const handleRetry = async (build: BuildInformationJsonData) => {
    const confirmation = window.confirm(`Are you sure you want to retry the build for commit SHA: ${build.commit_sha}?`);
    if (confirmation) {
      try {
        await api.resubmitBuilt(build);
        alert(`Build retry submitted successfully for commit SHA: ${build.commit_sha}`);
      } catch (error) {
        alert(`An error occurred while retrying the build: ${error}`);
      }
    }
  };

  const handlePreviousPage = async () => {
    if (offset > fetchLimit) {
      setOffset(offset - fetchLimit);
    } else if (offset > 0) {
      setOffset(0);
    }
  };

  const handleNextPage = async () => {
    if (data) {
      setOffset(offset + data.length);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const page = await api.getBuilds(offset, fetchLimit);
        setData(page.builds);
        setHasPrevious(offset > 0);
        setHasNext(page.next_offset !== undefined);
      } catch (error) {
        console.error('Failed to fetch builds:', error);
        authService.logout();
        navigate('/');
      }
    };

    fetchData();
  }, [offset, navigate]);

  if (data == null) {
    return <div className="spinner"></div>;
  }
  return (
    <div className="container mt-4">
      <table className="builds-table">
        <thead>
          <tr>
            <th>Commit SHA</th>
            <th>Commit Message</th>
            <th>Organization</th>
            <th>Status</th>
            <th>Last Status Update</th>
            <th>Last Status Message</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map(build => {
            const statusClass = {
              Building: 'building',
              Success: 'success',
              Pending: 'pending',
            }[build.status] || 'failed';
            return (
            <tr key={`${build.commit_sha}-${build.site_id ?? ''}-${build.create_time}`}>
              <td className="text-break">{build.commit_sha}</td>
              <td className="text-break">{build.commit_message}</td>
              <td className="text-break">{buildOrganizationLabel(build.organization)}</td>
              <td>
                <span className={`status-badge ${statusClass}`}>
                  {build.status}
                </span>
              </td>
              <td>{build.last_status_update ? new Date(build.last_status_update).toLocaleString() : ''}</td>
              <td>{build.last_status_message || ''}</td>
              <td>
                {build.status === 'Failed' && (
                  <button className="retry-btn" onClick={() => handleRetry(build)}>
                    Retry
                  </button>
                )}
              </td>
            </tr>
            );
          })}
        </tbody>
      </table>
      <div className="pagination-controls">
        <button className="pagination-btn" onClick={handlePreviousPage} disabled={!hasPrevious}>
          Previous
        </button>
        <button className="pagination-btn" onClick={handleNextPage} disabled={!hasNext}>
          Next
        </button>
      </div>
    </div>
  );
};

export default Builds;
